import { Transition } from "@headlessui/react";
import { cx } from "@jugl-web/utils";
import { FC, Fragment, ReactNode } from "react";
import {
  DRAWER_HEADER_HEIGHT_PX,
  DrawerHeader,
  TitleDrawerHeaderProps,
} from "../../overlay/DrawerHeader";

interface InlineSidebarProps {
  isOpen: boolean;
  children: ReactNode;
  onAfterLeave?: () => void;
}

export const InlineSidebar: FC<InlineSidebarProps> = ({
  isOpen,
  children,
  onAfterLeave,
}) => (
  <Transition
    show={isOpen}
    as={Fragment}
    enter="transition-transform duration-200"
    enterFrom="translate-x-full"
    enterTo="translate-x-0"
    leave="transition-transform duration-200"
    leaveFrom="translate-x-0"
    leaveTo="translate-x-full"
    afterLeave={onAfterLeave}
  >
    <div className="absolute top-0 right-0 z-10 h-full w-[400px] overflow-x-hidden overflow-y-auto bg-white shadow-[0px_24px_56px_0px_rgba(0,0,0,0.16)]">
      {children}
    </div>
  </Transition>
);

interface InlineSidebarHeaderProps
  extends Pick<TitleDrawerHeaderProps, "title" | "endSlot" | "onGoBack"> {
  onClose: () => void;
}

export const InlineSidebarHeader: FC<InlineSidebarHeaderProps> = ({
  title,
  endSlot,
  onClose,
  onGoBack,
}) => (
  <DrawerHeader
    type="title"
    title={
      <span className="font-secondary text-sm leading-[150%] font-semibold text-[#383838]">
        {title}
      </span>
    }
    endSlot={endSlot}
    onClose={onClose}
    onGoBack={onGoBack}
  />
);

interface InlineSidebarContentProps {
  children: ReactNode;
  className?: string;
}

export const InlineSidebarContent: FC<InlineSidebarContentProps> = ({
  children,
  className,
}) => (
  <div
    className={cx("jugl__custom-scrollbar overflow-y-auto", className)}
    style={{ height: `calc(100% - ${DRAWER_HEADER_HEIGHT_PX}px)` }}
  >
    {children}
  </div>
);
